export default "__VITE_ASSET__C9NRc0au__"